"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const leaflet_1 = __importDefault(require("leaflet"));
class CreateMarker {
    constructor(container) {
        this.container = container;
    }
    create(customIcon) {
        var _a;
        let template = (_a = this.container) === null || _a === void 0 ? void 0 : _a.querySelector('.c-openstreetmap__pin-icon');
        let html = template === null || template === void 0 ? void 0 : template.innerHTML;
        let icon = (customIcon === null || customIcon === void 0 ? void 0 : customIcon.icon) ? customIcon.icon : 'location_on';
        let color = (customIcon === null || customIcon === void 0 ? void 0 : customIcon.backgroundColor)
            ? customIcon.backgroundColor
            : this.getPrimaryColor();
        if (!html)
            return;
        html = html
            .replace('{icon-name}', icon)
            .replaceAll('{ICON_NAME}', icon)
            .replace('{ICON_BACKGROUND_COLOR}', color);
        let marker = leaflet_1.default.divIcon({
            className: 'c-openstreetmap__icon',
            html: html,
        });
        return marker;
    }
    getPrimaryColor() {
        let color = getComputedStyle(document.documentElement).getPropertyValue('--color-primary');
        return color ? color : '#ae0b05';
    }
}
exports.default = CreateMarker;
